<template>
    <div>
        <Modal class="printModal" :value="value" @on-visible-change="visibleChange" :mask-closable="false" width="1000" :closable="false">
            <div id="PrintArea">
                <table style="border: 1px solid #000; color: #000; font-family: 宋体; padding: 0px 20px" rules="all" width="100%">
                    <tr>
                        <th colspan="10" style="height: 40px; font-size: 20px; lin-height: 40px; font-weight: 400; border: 0">长沙金镂机械科技有限公司</th>
                    </tr>
                    <tr>
                        <th colspan="10" style="height: 40px; font-size: 20px; lin-height: 40px; border: 0">请假申请单</th>
                    </tr>
                    <tr>
                        <td colspan="3" style="border: 0; height: 30px; lin-height: 30px; padding-left: 10px">流水号：{{ initData.serialNumber }}</td>
                        <td colspan="7" style="border: 0; height: 30px; lin-height: 30px; padding-left: 10px"></td>
                    </tr>
                    <tr>
                        <td style="width:10%; height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">姓名</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.name}}</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">工号</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.number}}</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">部门</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.departmentText}}</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">职位</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.postText}}</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">工作代理人</td>
                        <td style="width:10%;height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.workAgent}}</td>
                    </tr>
                    <tr>
                        <td style="height: 70px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">请假事由</td>
                        <td colspan="9" style="height: 40px; width: 100px; text-align: center; font-size: 12px;  border: 1px solid #000;">{{initData.title}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="height: 80px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">请假明细</td>
                        <td colspan="2" style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">请假类别</td>
                        <td colspan="7" style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">请假时间</td>
                    </tr>
                    <tr>
                        <td colspan="2" style="height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.leaveTypeText}}</td>
                        <td colspan="7" style="height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{initData.leaveDateText}}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="height: 80px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">审批</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">直接上司</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">部门经理</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">人事行政部</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">总经理</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">执行董事</td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000"></td>
                    </tr>
                    <tr>
                        <td style="height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                        <td style="height: 40px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000"></td>
                    </tr>
                </table>
            </div>
            <div slot="footer">
                <Button @click="cancel" class="close-btn">取消</Button>
                <Button v-print="printObj" type="primary" class="close-btn">打印</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initData: {},
            list: {
            },
            form: {
                productType: [],
                dispose: [],
            },
            printObj: {
                id: 'PrintArea',
                // popTitle: "长沙金镂机械科技有限公司",
                // extraHead: '打印',
                // previewTitle:'长沙金镂机械科技有限公司',
                // previewPrintBtnLabel: '预览结束，开始打印',
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
                openCallback(vue) {},
                closeCallback(vue) {},
            },
        };
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        infoData: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        this.getInit();
    },
    methods: {
        async getInit() {
            this.$Spin.show();
            const data = await this.$Ajax.get(`/api/services/app/leave/GetPrintData?id=${this.infoData}`);
            this.initData = data.data.result;
            this.$Spin.hide();
        },
        visibleChange(value) {
            if (!false) {
                this.$emit('succesConfirm', value);
            }
        },
        cancel() {
            this.$emit('succesConfirm', false);
        },
    },
};
</script>

<style lang="less" scoped>
@media print {
    /*最外层打印节点*/
    #PrintArea {
        display: block;
        height: auto;
        overflow: hidden;
    }
}

/deep/.ivu-modal-header-inner {
    font-size: 20px;
    text-align: center;
}

.printModal /deep/ .ivu-modal {
    top: 0;
}
.ivu-modal-footer > div {
    text-align: center;
}

// checkbox禁用checked样式修改
input[type='checkbox'] {
    width: 12px;
    height: 12px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 12px;
    position: relative;
}

input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #cacdcf;
}

input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #000;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border: 1px solid #000;
    font-size: 12px;
    font-weight: bold;
}
</style>
